export default "__VITE_ASSET__DxSQE6QR__"